// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type FolderFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from folder-filled.svg
 */
export default function FolderFilledIcon(props: FolderFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="FolderFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M1.356 1.007A1.5 1.5 0 0 0 0 2.5V4h16v-.5l-.007-.144A1.5 1.5 0 0 0 14.5 2H5.915A1.5 1.5 0 0 0 4.5 1h-3zM16 13.5V5H0v8.5l.007.145A1.5 1.5 0 0 0 1.5 15h13l.145-.007A1.5 1.5 0 0 0 16 13.5"
        />
      </g>
    </svg>
  );
}
